function Slogan() {
  const date = new Date().getFullYear();
  return (
    <div className="w-2/3 h-full">
      <div className="w-full h-2/4 text-white flex items-center">
        <h3>
          در سکوت به تلاشت ادامه بده، بگذار موفقیت هایت به جای تو حرف بزنند!
        </h3>
      </div>
      <div className="w-full h-2/4 flex flex-col items-end pt-24">
        <p className="text-gray-500 font-extralight cursor-default">
          کپی رایت ©{date + " "}تمامی حقوق محفوظ است
        </p>
      </div>
    </div>
  );
}

export default Slogan;
